import { DeleteClientBankAccountRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useDeleteBankAccount() {
  const api = useApi();
  const [deleting, setDeleting] = useState(false);

  // PortalUser omitted: the handler reads only Token (verified against lib/www/routes/v2/bank_account.php)
  // — the backend takes the user from the JWT. Unlike its siblings' request types, this one declares
  // PortalUser required, so without the Omit every caller has to invent a value the backend ignores.
  async function deleteBankAccount(params: Omit<DeleteClientBankAccountRequest, 'PortalUser'>) {
    try {
      setDeleting(true);
      const res = await api.postDeleteClientBankAccount(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setDeleting(false);
    }
  }

  return { deleting, deleteBankAccount };
}
